import type { GameCommand, GameState } from './types';
import { applyCommand, ECONOMY_TICK } from './simulation';

export type StoreListener = (state: GameState, command?: GameCommand) => void;

export class GameStore {
  private state: GameState;
  private listeners = new Set<StoreListener>();
  private timer: number | null = null;
  private lastTick = 0;

  constructor(initialState: GameState) {
    this.state = initialState;
  }

  getState = (): GameState => this.state;

  subscribe = (listener: StoreListener): (() => void) => {
    this.listeners.add(listener);
    listener(this.state);
    return () => this.listeners.delete(listener);
  };

  dispatch = (command: GameCommand): void => {
    this.state = applyCommand(this.state, command);
    this.listeners.forEach((listener) => listener(this.state, command));
  };

  replaceState = (state: GameState): void => {
    this.state = state;
    this.listeners.forEach((listener) => listener(this.state));
  };

  start = (): void => {
    if (this.timer !== null) return;
    this.lastTick = performance.now();
    this.timer = window.setInterval(() => {
      const now = performance.now();
      const delta = Math.min(2, Math.max(ECONOMY_TICK, (now - this.lastTick) / 1000));
      this.lastTick = now;
      this.dispatch({ type: 'tick', deltaSeconds: delta });
    }, ECONOMY_TICK * 1000);
  };

  stop = (): void => {
    if (this.timer !== null) window.clearInterval(this.timer);
    this.timer = null;
  };
}
